/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Person_Has_RecordsInputs */

const fr_error_person_has_records = /** @type {(inputs: Error_Person_Has_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette personne a des heures ou un compte actif. Retirez son accès à la place.`)
};

const en_error_person_has_records = /** @type {(inputs: Error_Person_Has_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This person has time or an active sign-in. Remove their access instead.`)
};

/**
* | output |
* | --- |
* | "This person has time or an active sign-in. Remove their access instead." |
*
* @param {Error_Person_Has_RecordsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_person_has_records = /** @type {((inputs?: Error_Person_Has_RecordsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Person_Has_RecordsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_person_has_records(inputs)
	return fr_error_person_has_records(inputs)
});